import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    cate = '',
    group = '',
    userId,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.perms.getUserPerms, {
        cate,
        group,
        userId,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};

